import { Link } from "react-router-dom";
import { ArrowLeft, Clapperboard } from "lucide-react";

const sections = [
  { h: "All sales are final", p: "Every order is paid in full at checkout and production starts right away. Because each video is custom-made for your brand, we do not offer refunds once payment is complete." },
  { h: "No replacements", p: "Delivered videos are not replaced or remade from scratch. Please make sure your product URL, brand guidelines and assets are complete and correct before you pay." },
  { h: "No revisions", p: "Videos are delivered as final. We do not offer revisions or edits after delivery, so please share everything we need — product URL, brand guidelines, logo and assets — when you place your order." },
  { h: "Questions", p: "If you have any questions about this policy before ordering, email us at connect@itmunch.com." },
];

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-[#0A0B10] text-[#F8F9FA]" data-testid="refund-policy-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12 lg:py-20">
        <Link to="/" data-testid="refund-policy-back-link" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to iTMunch Viral Videos
        </Link>
        <div className="mt-10 flex items-center gap-3">
          <span className="grid place-items-center w-10 h-10 rounded-lg bg-[#FF2E63]"><Clapperboard className="w-5 h-5 text-white" /></span>
          <p className="text-xs font-mono uppercase tracking-widest text-[#00F5D4]">Policy</p>
        </div>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight">Refund Policy</h1>
        <p className="mt-4 text-lg text-slate-300 border-l-2 border-[#FF2E63] pl-4" data-testid="refund-policy-summary">
          No refunds, replacements or revisions.
        </p>
        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-lg font-bold">{s.h}</h2>
              <p className="mt-2 text-slate-400 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
